module.exports = __webpack_public_path__ + "img/logo.3c866da5.png";